import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, ICheckboxOptions } from '../../../../../component';
import { handleCheckbox } from '../../controllers/dataLayers.controller';
import { RootState } from '../../../../../reducer';
import { Map } from 'eemovel-map-library';
import {
  removeFlowPoint,
  switchAllFlowPoints,
} from '../../redux/dataLayers.map';
import { loaded, loading } from '../../../../../layout/redux/layoutActions';
import { useEffect, useState } from 'react';

function FlowPointsSwitch() {
  const {
    dataLayersState: { dataLayers },
    polygonsState: { draw },
  } = useSelector((state: RootState) => state);

  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      isLoading &&
      dataLayers.flowPoints.options.every((option) => option.checked)
    ) {
      dispatch(loaded());
    }
  }, [isLoading, dataLayers.flowPoints.options]);

  const handleOnClick = (isActive: boolean) => {
    if (isActive) {
      let poligonBounds = new google.maps.LatLngBounds();
      if (draw.type === 'polygon') {
        Map.PoligonOnMap.getPath().forEach((latlng) => {
          poligonBounds.extend(latlng);
        });
      }

      const payload = {
        ...(draw.type === 'circle' && {
          center: draw.center,
          radius: draw.radius,
        }),
        ...(draw.type === 'polygon' &&
          !poligonBounds.isEmpty() && {
            coords: draw.coords,
            bounds: poligonBounds,
          }),
      };

      handleCheckbox(
        isActive as unknown as ICheckboxOptions,
        'Pontos de fluxo',
        'flowPoints'
      );

      const data = dataLayers.flowPoints.options.map((option) => option);
      setIsLoading(true);
      dispatch([loading(), switchAllFlowPoints(data, payload)]);
      return;
    }

    dataLayers.flowPoints.options.forEach((option) => {
      removeFlowPoint(option);
    });

    handleCheckbox(
      isActive as unknown as ICheckboxOptions,
      'Pontos de fluxo',
      'flowPoints'
    );
  };

  const hasDrawOnMap = draw.isActive;

  return (
    <Checkbox
      cy={'DataLayerFlowPoint'}
      action={(event) => {
        handleOnClick(event as boolean);
      }}
      disabled={!hasDrawOnMap}
      name={dataLayers.flowPoints.id}
      checked={dataLayers.flowPoints.options.some(({ checked }) => checked)}
      type="switch"
    />
  );
}

export default FlowPointsSwitch;
